import { render, staticRenderFns } from "./MailingLists.vue?vue&type=template&id=1bf701f9&"
import script from "./MailingLists.vue?vue&type=script&lang=js&"
export * from "./MailingLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports